import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { getFirebaseToken } from "../../services/firebase";
import { useAppDispatch } from "../../store";
import { registerNotificationDevice } from "../../store/general/general-actions";

const NotificationHandler: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleGetFirebaseToken = useCallback(() => {
    getFirebaseToken().then((firebaseToken: string | undefined) => {
      if (firebaseToken) {
        dispatch(registerNotificationDevice(firebaseToken));
      }
    });
  }, [dispatch]);

  // const onMessageListener = useCallback(async () => {
  //   const messagingResolve = await messaging;
  //   if (messagingResolve) {
  //     onMessage(messagingResolve, (payload: MessagePayload) => {
  //       if (payload.notification != null) {
  //         toast.info(<NotificationToastBody title={payload.notification.title} body={payload.notification.body} />, {
  //           className:
  //             payload.notification.image != null || payload.notification.icon != null ? classes.toast : undefined,
  //           icon:
  //             payload.notification.icon != null ? (
  //               <img src={payload.notification.icon} alt="" width="20px" />
  //             ) : payload.notification.image != null ? (
  //               <img src={payload.notification.image} alt="" width="20px" />
  //             ) : undefined,
  //           autoClose: false,
  //         });
  //       }
  //     });
  //   }
  // }, [classes.toast]);

  useEffect(() => {
    if (Capacitor.isNativePlatform() || 'Notification' in window) {
      handleGetFirebaseToken();
      // onMessageListener();
    }
  }, [handleGetFirebaseToken]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const listener = PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
      const url = action.notification.data?.url;
      if (!url) return;
      try {
        const parsed = new URL(url);
        navigate(`${parsed.pathname}${parsed.search}`);
      } catch (error) {
        console.error("Failed to parse push notification url", error);
      }
    });

    return () => {
      listener.then((l) => l.remove());
    };
  }, [navigate]);

  // const UrlFirebaseConfig = new URLSearchParams(firebaseConfig.toString());
  // const swUrl = `http://localhost:3000/firebase-messaging-sw.js?${UrlFirebaseConfig}`;

  return <></>;
};

export default NotificationHandler;
